import React from "react";
import Datetime from "react-datetime";

// material-ui components
import InputLabel from "material-ui/Input/InputLabel";
import FormControlLabel from "material-ui/Form/FormControlLabel";
import FormControl from "material-ui/Form/FormControl";
import Switch from "material-ui/Switch";

// core components
import ItemGrid from "components/Grid/ItemGrid.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";

function SimpleInput({ ...props }) {
  let {
  	type,
    classes,
    label,
    name,
    value,
    handler,
    formName,
    size,
    success,
    error,
  } = props;


  	if(!type) type="text";

	return (
        <ItemGrid xs={12} sm={size}>
          {type==="text"?(
          <CustomInput
            success={success}
          	error={error}
            labelText={label}
            id={formName+"-"+name}
            formControlProps={{
              fullWidth: true
            }}
            inputProps={{
              onChange: event => handler(event, name, "length", 3),
              name:name,
              value:(value!==null)?value:"",
            }}            
          />):""}
          {type==="datetime"?(
          	<div>
        	  <InputLabel className={classes.label}>
	            Datetime Picker
	          </InputLabel>
	          <FormControl fullWidth>
	            <Datetime
                onChange={event => handler(event, name, "moment") }
                value={value}
	              inputProps={{ 
                  placeholder: "",
                  name:name,
                 }}
	            />
	          </FormControl>
	         </div>
          ):""}
	      {type==="toggle"?(
	      <FormControlLabel
	        control={
	          <Switch
	            onChange={event => handler(event, name) }
	            name={name}
	            checked={value}
	          />
	        }
	        classes={{
	          label: classes.label
	        }}
	        label={label}
          />):""}	         
        </ItemGrid>	
  );
}

export default SimpleInput;



// WEBPACK FOOTER //
// ./src/components/SimpleInput/SimpleInput.jsx